import React, { useMemo, useRef, useState } from "react";
import { Form, InputNumber, DatePicker, ConfigProvider, message, Select, Modal, Input } from "antd";
import zh_TW from "antd/lib/locale-provider/zh_TW";
import "moment/dist/locale/zh-tw";
import dayjs from "dayjs";
import Cookies from 'js-cookie';
import BrandsKindSelectDom from "./oneNewCarBkMSelect";
import ThrottleButton from "./throttleButton";
import SelectArrow from "./iconComponent/selectArrow";
import styles from "./index.module.less";
import { useSetState } from "ahooks";
import { appraiseTips } from "@Api";
import { host } from "@Services/url";
import cx from "classnames";
import { colorList } from "./constants";

const OUTSIDE_PC_SOURCE_KEY = "outside-pc-source";
const OUTSIDE_PC_ENTRY_KEY = "outside-pc-entry";

export const getSource = (source: string) => {
  if (Cookies.get(OUTSIDE_PC_SOURCE_KEY)) {
    return Cookies.get(OUTSIDE_PC_SOURCE_KEY);
  } else {
    return source;
  }
};

export const getEntry = (entry: string) => {
  if (Cookies.get(OUTSIDE_PC_ENTRY_KEY)) {
    return Cookies.get(OUTSIDE_PC_ENTRY_KEY);
  } else {
    return entry;
  }
};

const { fetchCarResourceValuation } = appraiseTips;

const AppraiseTips = () => {
  const [form] = Form.useForm();
  const selectRef = useRef<any>(null);
  const [error, setError] = useState(false);
  const [leaveThefactoryDate, setLeaveThefactoryDate] = useState<any>(undefined);
  const [formData, setform] = useSetState<any>({
    brandId: "",
    kindId: "",
    modelYearId: "",
    makeYear: "",
    makeMonth: "",
    color: null,
    mileage: "",
  });

  const [open, setOpen] = useState(false);
  const [extraColor, setExtraColor] = useState("");

  const btnTxt = useMemo(() => {
    const { brandId, kindId, modelYearId, makeYear, makeMonth, mileage, color } = formData;
    if (!!brandId && !!kindId && !!modelYearId && !!makeYear && !!makeMonth && !!mileage && !!color) {
      return "查看估價結果";
    } else {
      return "立即估價";
    }
  }, [formData]);

  // const checkBrandSelect = () => {
  //   if (formData.brandId && formData.kindId && formData.modelYearId) {
  //     setError(false);
  //     return Promise.resolve();
  //   }
  //   if (!(formData.brandId && formData.kindId)) {
  //     setError(true);
  //     message.error("請選擇廠牌車款!");
  //     return Promise.reject();
  //   }
  //   if (!formData.modelYearId) {
  //     setError(true);
  //     message.error("請選擇年式車型!");
  //     return Promise.reject();
  //   }

  //   setError(true);
  //   message.error("請選擇廠牌車款車型!");
  //   return Promise.reject();
  // };

  const startFormCheck = () => {
    const requiredFields = ["modelYearId", "makeMonth", "color", "mileage"];
    let unPass: string[] = [];

    if (!(formData.brandId && formData.kindId)) {
      unPass.push("brandId", "kindId");
    }

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        unPass.push(field);
      }
    });

    return {
      selectedAllCondition: unPass.length === 0,
      unPass,
    };
  };

  const onFinish = async () => {
    const checkResult = startFormCheck();
    const { brandId, kindId, modelYearId, makeYear, makeMonth, mileage, color } = formData;
    const colorItem = colorList.find((item) => item.value === color);
    const resColor = !!colorItem ? colorItem.name : color;

    if (checkResult.selectedAllCondition) {
      // 如果所有条件都填了跳估价结果页
      const res: any = await fetchCarResourceValuation({
        brandId: brandId,
        kindId: kindId,
        modelYearId: modelYearId,
        makeDate: `${makeYear}${makeMonth}`,
        mileage: (isNaN(Number(mileage)) ? 0 : Number(mileage)) * 10000,
        color: resColor,
        source: getSource("8891"),
        entry: getEntry("nc_op_hp_fm_fv"),
      });
      if (res?.status === 12000) {
        window.open(
          `${host.auto}/carResource-carResourceAppraiseResult.html?id=${res?.data?.id}&pass=${res?.data?.pass}&source=${getSource("8891")}&entry=${getEntry("uc_csp_lrs_vfe")}`,
        );
        return;
      }
      message.error(res?.data?.content);
    } else {
      // 如果有条件没填跳估价首页
      let urlObj = {
        ...formData,
        color: resColor,
        newCar: 1,
      };

      Object.keys(urlObj).forEach((key) => {
        if (!urlObj[key]) {
          Reflect.deleteProperty(urlObj, key);
        }
      });

      let params = new URLSearchParams(urlObj);
      let queryString = params.toString();

      window.open(`${host.auto}/carResource/valuation?source=8891&entry=uc_csp_lrs_ve&${queryString}`);
    }
  };

  // const checkYearMonth = () => {
  //   if (formData.makeMonth !== undefined && formData.makeMonth !== null && formData.makeMonth !== "") {
  //     return Promise.resolve();
  //   }
  //   message.error("請選擇出廠年月!");
  //   return Promise.reject();
  // };
  // const checkColor = () => {
  //   if (formData.color !== undefined && formData.color !== null && formData.color !== "") {
  //     return Promise.resolve();
  //   }
  //   message.error("請選擇顏色!");
  //   return Promise.reject();
  // };

  const handleCloseModal = () => {
    setOpen(false);
    setExtraColor("");
    setform((prev) => ({ ...prev, color: null }));
  };

  const handleConfirm = () => {
    if (extraColor.trim() === "") {
      message.error("請輸入顏色!");
      return;
    }
    setform((prev) => ({ ...prev, color: extraColor }));
    form.setFieldsValue({
      ...formData,
      color: extraColor,
    });
    setOpen(false);
  };

  return (
    <div className={styles["appraise-tips-wrapper"]}>
      <ConfigProvider locale={zh_TW}>
        <div className={styles["appraise-tips-header"]}></div>
        <div className={styles["appraise-tips-form"]}>
          <Form
            id='car-resource-appraise-form'
            style={{ height: "100%" }}
            form={form}
            name='basic'
            wrapperCol={{ span: 22 }}
            initialValues={formData}
            onFinish={onFinish}
            autoComplete='off'
            validateMessages={{}}
          >
            <div className={styles["form-container"]}>
              <Form.Item
                label=''
                name='brand'
                // rules={[{ required: true, validator: checkBrandSelect }]}
                className={styles["brand-form-item"]}
              >
                <BrandsKindSelectDom
                  className={styles["brand-kind-select"]}
                  selectType='brandKind'
                  modelYearType='valuation2'
                  size='large'
                  error={error}
                  ref={selectRef}
                  placeholder='選擇廠牌車型'
                  onSubmit={(data) => {
                    console.log("submitData", data);
                    setError(false);
                    setform((prev) => ({ ...prev, ...data }));
                    form.setFieldsValue({
                      ...formData,
                      ...data,
                    });
                    if (data.modelYearId) {
                      form.validateFields(["brand"]);
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label=''
                required
                name='leaveThefactoryDate'
                // rules={[{ required: true, validator: checkYearMonth }]}
                className={styles["date-form-item"]}
              >
                <DatePicker
                  inputReadOnly
                  value={leaveThefactoryDate}
                  className={styles["car-valuation-datepicker"]}
                  popupClassName={styles["car-valuation-datepopup"]}
                  format={"YYYY年MM月"}
                  allowClear={false}
                  placeholder='出廠年月'
                  disabledDate={(current) => {
                    // @ts-ignore
                    let tooLate = current && current > dayjs().endOf("day");
                    // @ts-ignore
                    let tooEarly = current && current < dayjs("1990-01-01");

                    return tooLate || tooEarly;
                  }}
                  style={{ width: "240px", height: "40px" }}
                  onChange={(val: any) => {
                    setLeaveThefactoryDate(val);
                    setform((prev) => ({
                      ...prev,
                      makeYear: val.format("YYYY"),
                      makeMonth: val.format("MM"),
                    }));
                    form.validateFields(["leaveThefactoryDate"]);
                  }}
                  picker='month'
                />
              </Form.Item>

              <Form.Item
                label=''
                required
                name='color'
                // rules={[{ required: true, validator: checkColor }]}
                className={styles["date-form-item"]}
              >
                <Select
                  suffixIcon={<SelectArrow />}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder='顏色'
                  size='large'
                  style={{ width: "240px", height: "40px" }}
                  value={formData.color}
                  onChange={(val) => {
                    if (val === 12) {
                      setOpen(true);
                      setform((prev) => ({ ...prev, color: null }));
                      form.setFieldsValue({
                        ...formData,
                        color: null,
                      });
                      return;
                    }
                    setform((prev) => ({ ...prev, color: val }));
                  }}
                >
                  {colorList.map((item) => {
                    if (item.name === "其他") {
                      return (
                        <Select.Option key={item.name} value={item.value}>
                          <div>{item.name}</div>
                        </Select.Option>
                      );
                    }

                    return (
                      <Select.Option key={item.color} value={item.value}>
                        <div className={styles["color-wrap"]}>
                          <div
                            className={styles["color-container"]}
                            style={{
                              backgroundColor: `${item.color}`,
                              border: item.name === "白色" ? "1px solid #e0e0e0" : "none",
                            }}
                          />
                          <div>{item.name}</div>
                        </div>
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <div className={styles["mileage-form-wrapper"]}>
                <Form.Item
                  label=''
                  name='mileage'
                  // rules={[
                  //   {
                  //     required: true,
                  //     validator: (_, value) => {
                  //       if (!value) {
                  //         message.error("請輸入里程數!");
                  //         return Promise.reject();
                  //       }
                  //       return Promise.resolve();
                  //     },
                  //   },
                  // ]}
                >
                  <InputNumber
                    className={styles["mileage-input"]}
                    controls={false}
                    size='large'
                    // bordered={false}
                    min={0}
                    max={99.99}
                    maxLength={3}
                    type='number'
                    placeholder='行駛里程'
                    precision={2}
                    style={{ width: 240 }}
                    addonAfter={<div className={styles["mileage-info"]}>萬公里</div>}
                    onChange={(v) => setform((prev) => ({ ...prev, mileage: v }))}
                  />
                </Form.Item>
              </div>

              <div className={cx(styles["btn-wrap"], "tracking-autos-valuation-appraise-btn")}>
                <ThrottleButton
                  delay={1000}
                  type={"submit"}
                  onClick={() => {
                    form.submit();
                  }}
                  className={cx(styles["submit-btn"])}
                >
                  {btnTxt}
                </ThrottleButton>
              </div>
            </div>
          </Form>

          <Modal open={open} title={null} onCancel={handleCloseModal} footer={null} width={300}>
            <div className={styles["modal-content"]}>
              <div className={styles["modal-title"]}>其他顏色</div>
              <div className={styles["modal-input"]}>
                <Input
                  size='large'
                  placeholder='請輸入'
                  onChange={(e) => setExtraColor(e.target.value)}
                  value={extraColor}
                />
              </div>
              <div className={styles["modal-btn"]}>
                <div className={styles["modal-btn-cancel"]} onClick={handleCloseModal}>
                  取消
                </div>
                <div className={styles["modal-btn-confirm"]} onClick={handleConfirm}>
                  確認
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </ConfigProvider>
    </div>
  );
};

export default AppraiseTips;
